export default __webpack_public_path__ + "static/media/developer30_preview.png";